import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import DataContainer from 'Components/UI/DataContainer';
import classNames from 'classnames';
import fr from 'facet-rest';
import Content from './Content';

const styles = () => ({
  root: {
    paddingBottom: 0,
  },
});

const Container = ({
  className,
  classes,
  resource,
}) => {
  const [errors, setErrors] = useState();
  const [loading, setLoading] = useState(true);
  const [collection, setCollection] = useState([]);

  const fetchActionItems = async () => {
    setLoading(true);
    try {
      const actionItemCollection = await resource.relationship(fr.relationships.actionItems.name)?.link('related').get();
      setCollection(actionItemCollection);
    } catch (e) {
      setErrors(e.errors);
    }
    setLoading(false);
  };
  useComponentDidMount(() => {
    fetchActionItems();
  });


  return (
    <DataContainer
      className={classNames(className, classes.root)}
      component={Content}
      componentProps={{
        collection,
        content: resource.attr('content'),
        subcontent: resource.attr('subcontent'),
      }}
      loading={loading}
      loadingError={errors}
    />
  );
};

Container.defaultProps = {
  className: '',
};

Container.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default withStyles(styles)(Container);
